/** Shared patient workspace / cohort-match UI constants (legacy Redux `patient` slice removed). */
import { NO_LONGER_A_CANDIDATE_REASONS } from '@tempus/trials-types';
import { PatientCohortMatchWorkflowState } from '@tempus/stateflow-types';
import { PatientCohortMatchStates } from '@tempus/trials-types';

import { InternalReviewScreeningOpt } from '~/store/patientTrackerV3/constants';

export enum PATIENT_PAGE_TAB {
  PATIENT = 'patient',
  EVALUATION = 'evaluation',
  TRACKING = 'tracking',
}

/*
 * BEGIN PATIENT COHORT MATCH TRACKING
 */
export const additionalStatusNoteIneligibleStatuses: Array<
  PatientCohortMatchStates | PatientCohortMatchWorkflowState | InternalReviewScreeningOpt
> = [
  InternalReviewScreeningOpt.REQUEST_RESCREEN_SCREEN_LATER,
  InternalReviewScreeningOpt.REQUEST_RESCREEN_CASE_REVIEW,
  InternalReviewScreeningOpt.RESET_TO_UNSCREENED,
  PatientCohortMatchStates.INTERNAL_REVIEW,
  PatientCohortMatchStates.INTERNAL_REVIEW_NOT_ELIGIBLE,
  PatientCohortMatchStates.PENDING_TEMPUS_REVIEW,
  PatientCohortMatchStates.PENDING_SITE_REVIEW,
  PatientCohortMatchStates.ENROLLED,
  PatientCohortMatchStates.NO_LONGER_A_CANDIDATE,
  PatientCohortMatchWorkflowState.INTERNAL_REVIEW,
  PatientCohortMatchWorkflowState.INTERNAL_REVIEW_NOT_ELIGIBLE,
  PatientCohortMatchWorkflowState.PENDING_TEMPUS_REVIEW,
  PatientCohortMatchWorkflowState.PENDING_SITE_REVIEW,
  PatientCohortMatchWorkflowState.ENROLLED,
  PatientCohortMatchWorkflowState.NO_LONGER_A_CANDIDATE,
];

export const additionalStatusNotePlaceholders: Partial<Record<PatientCohortMatchWorkflowState, string>> = {
  [PatientCohortMatchWorkflowState.WATCHLIST]:
    'How is the patient doing now? Have they had any recent scans or eligibility concerns? Have they changed treatments?',
  [PatientCohortMatchWorkflowState.PURSUING_ACTIVATION]: 'Is there a planned consent date?',
  [PatientCohortMatchWorkflowState.IMMINENT_CANDIDATE]:
    'Is the MD aware of the trial? Has the patient been talked to about the trial, and if so have they expressed interest in participating? Is there a planned consent date?',
  [PatientCohortMatchWorkflowState.CONSENTED]: 'Is there a planned cycle 1 day 1?',
};

export const preconsentDateEligibleStatuses = [
  PatientCohortMatchStates.WATCHLIST,
  PatientCohortMatchStates.IMMINENT_CANDIDATE,
  PatientCohortMatchStates.PURSUING_ACTIVATION,
  PatientCohortMatchWorkflowState.WATCHLIST,
  PatientCohortMatchWorkflowState.IMMINENT_CANDIDATE,
  PatientCohortMatchWorkflowState.PURSUING_ACTIVATION,
];

export const WATCHLIST_OPT_AFTER_NEXT_VISIT = 'After next visit';
export const WATCHLIST_OPT_AFTER_A_DATE = 'After a date';

export const watchlistUntilDropdownOpts = [
  { value: WATCHLIST_OPT_AFTER_NEXT_VISIT, label: WATCHLIST_OPT_AFTER_NEXT_VISIT },
  { value: WATCHLIST_OPT_AFTER_A_DATE, label: WATCHLIST_OPT_AFTER_A_DATE },
];
/*
 * END PATIENT COHORT MATCH TRACKING
 */

export const reasonNotAMatchOptions = Object.values(NO_LONGER_A_CANDIDATE_REASONS)
  .sort()
  .map((value) => ({ label: value, value }));
